import { render, staticRenderFns } from "./legendBox14.vue?vue&type=template&id=50dd4f33&scoped=true&"
import script from "./legendBox14.vue?vue&type=script&lang=js&"
export * from "./legendBox14.vue?vue&type=script&lang=js&"
import style0 from "./legendBox14.vue?vue&type=style&index=0&id=50dd4f33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd4f33",
  null
  
)

export default component.exports